document.addEventListener('DOMContentLoaded', () => {

    const recommendationMap = [
        { Q1: 'Smoker', Q2: 'No', Q3: 'Fruit', Recommendation: 'Watermelon 6mg (Regular)' },
        { Q1: 'Smoker', Q2: 'No', Q3: 'Mint', Recommendation: 'Menthol 6mg (Regular)' },
        { Q1: 'Smoker', Q2: 'Yes', Q3: 'Fruit', Recommendation: 'Berry 11mg (Strong)' },
        { Q1: 'Smoker', Q2: 'Yes', Q3: 'Mint', Recommendation: 'Menthol 11mg (Strong)' },
        { Q1: 'Vaper', Q2: 'No', Q3: 'Fruit', Recommendation: 'Watermelon 6mg (Regular)' },
        { Q1: 'Vaper', Q2: 'No', Q3: 'Mint', Recommendation: 'Menthol 6mg (Regular)' },
        { Q1: 'Vaper', Q2: 'Yes', Q3: 'Fruit', Recommendation: 'Berry 11mg (Strong)' },
        { Q1: 'Vaper', Q2: 'Yes', Q3: 'Mint', Recommendation: 'Menthol 11mg (Strong)' },
        { Q1: 'Neither', Q2: 'No', Q3: 'Fruit', Recommendation: 'Watermelon 6mg (Regular)' },
        { Q1: 'Neither', Q2: 'No', Q3: 'Mint', Recommendation: 'Menthol 6mg (Regular)' },
        { Q1: 'Neither', Q2: 'Yes', Q3: 'Fruit', Recommendation: 'Watermelon 6mg (Regular)' },
        { Q1: 'Neither', Q2: 'Yes', Q3: 'Mint', Recommendation: 'Menthol 6mg (Regular)' },
    ];

    const products = {
        'Watermelon 6mg (Regular)': {
            title: 'WATERMELON',
            strength: 'Regular : 6mg / pouch',
            description: 'A sweet watermelon flavour with a refreshing finish.',
            image: '//cdn.shopify.com/s/files/1/0559/7075/8753/files/watermelon_6mg.jpg',
            url: '/products/watermelon',
            flavorValue: 'Watermelon',
            strengthValue: 'Regular: 6mg',
        },
        'Menthol 6mg (Regular)': {
            title: 'MENTHOL',
            strength: 'Regular : 6mg / pouch',
            description: 'Refreshing mint flavour perfect for beginners.',
            image: '//cdn.shopify.com/s/files/1/0559/7075/8753/files/Menthol_-_6mg.jpg',
            url: '/products/menthol',
            flavorValue: 'Menthol',
            strengthValue: 'Regular: 6mg',
        },
        'Berry 11mg (Strong)': {
            title: 'BERRY',
            strength: 'Strong : 11mg / pouch',
            description: 'Sweet berry flavour with stronger nicotine.',
            image: '//cdn.shopify.com/s/files/1/0559/7075/8753/files/Berry_front_-_11mg.jpg',
            url: '/products/berry',
            flavorValue: 'Berry',
            strengthValue: 'Strong: 11mg',
        },
        'Menthol 11mg (Strong)': {
            title: 'MENTHOL',
            strength: 'Strong : 11mg / pouch',
            description: 'Classic menthol with higher nicotine strength.',
            image: '//cdn.shopify.com/s/files/1/0559/7075/8753/files/Menthol_-_11mg.jpg',
            url: '/products/menthol',
            flavorValue: 'Menthol',
            strengthValue: 'Strong: 11mg',
        },
    };

    const steps = document.querySelectorAll('.quiz-step');

    let currentStep = 0;

    const answers = {
        Q1: null,

        Q2: null,

        Q3: null,
    };

    function showStep(index) {
        steps.forEach((step) => step.classList.remove('active'));

        steps[index].classList.add('active');

        currentStep = index;
    }

    showStep(0);

    document.querySelectorAll('.quiz-step').forEach((step, index) => {
        const options = step.querySelectorAll('.quiz-option');

        const nextBtn = step.querySelector('.quiz-next');

        const submitBtn = step.querySelector('.quiz-submit');

        options.forEach((option) => {
        option.addEventListener('click', () => {
            options.forEach((o) => o.classList.remove('active'));

            option.classList.add('active');

            const value = option.dataset.value;

            if (index === 0) answers.Q1 = value;
            if (index === 1) answers.Q2 = value;
            if (index === 2) answers.Q3 = value;

            if (nextBtn) nextBtn.disabled = false;

            if (submitBtn) submitBtn.disabled = false;
        });
        });
    });

    document.querySelectorAll('.quiz-next').forEach((btn) => {
        btn.addEventListener('click', () => {
        showStep(currentStep + 1);
        });
    });

    document.querySelectorAll('.quiz-back').forEach((btn) => {
        btn.addEventListener('click', () => {
        showStep(currentStep - 1);
        });
    });

    document.querySelector('.quiz-submit').addEventListener('click', () => {
        const recommendation = recommendationMap.find((item) => {
        return item.Q1 === answers.Q1 && item.Q2 === answers.Q2 && item.Q3 === answers.Q3;
        });

        if (!recommendation) {
        alert('No recommendation found.');

        return;
        }

        populateResult(recommendation.Recommendation);

        showStep(3);
    });

    function populateResult(name) {
        const product = products[name];
        //console.log(product);
        if (!product) return;
        document.getElementById('recommended-product').textContent = name;
        document.getElementById('product-name').textContent = product.title;
        document.getElementById('product-description').textContent = product.description;
        document.getElementById('strength-select').textContent = product.strength;
        document.querySelector('.result-image img').src = product.image;
        // Sync with claim form dropdowns
        const flavorSelect = document.getElementById('flavor');
        const strengthSelect = document.getElementById('strength');
        const variantInput = document.getElementById('variant-id');

        if (flavorSelect && product.flavorValue) {
            // Find flavor option by text
            const flavorOption = Array.from(flavorSelect.options).find(
                opt => opt.textContent.trim().toLowerCase() === product.flavorValue.toLowerCase()
            );
            if (flavorOption) {
                flavorSelect.value = flavorOption.value;
                flavorSelect.dispatchEvent(new Event('change', { bubbles: true }));

                // Wait for strengths to populate, then select strength
                setTimeout(() => {
                    const strengthOption = Array.from(strengthSelect.options).find(
                        opt => opt.textContent.trim().toLowerCase() === product.strengthValue.toLowerCase()
                    );
                    if (strengthOption) {
                        strengthSelect.value = strengthOption.value;
                        strengthSelect.dispatchEvent(new Event('change', { bubbles: true }));
                    }
                }, 100);
            }
        }
    }
});